import styles from "./whyAndy.module.css";
import { whyAndyImage1, whyAndyImage2, whyAndyImage3, whyAndyImage4 } from "@/assets/images";

type WhyAndyCard = {
  title: string;
  description: string;
  icon: React.ReactNode;
  highlighted?: boolean;
};

const cards: WhyAndyCard[] = [
  {
    title: "Automated Process",
    description: "Everything is handled automatically, saving you time and effort.",
    icon: <img src={whyAndyImage1} alt="Why Andy" />,
  },
  {
    title: "Affordable Fees",
    description: "Clear, transparent pricing with no hidden costs.",
    icon: <img src={whyAndyImage2} alt="Why Andy" />,
    highlighted: true,
  },
  {
    title: "Guided Steps",
    description: "Step-by-step guidance from start to finish",
    icon: <img src={whyAndyImage3} alt="Why Andy" />,
  },
  {
    title: "Fast Review",
    description: "Quick evaluation without long waiting periods.",
    icon: <img src={whyAndyImage4} alt="Why Andy" />,
  },
];

export const WhyAndy = () => {
  return (
    <section className={styles.whyAndySection}>
      <div className={styles.whyAndyFrame}>
        <div className={styles.heading}>
          <h2 className={styles.title}>
            Why <span className={styles.andy}>Andy ?</span>
          </h2>
          <p className={styles.subtitle}>The Better Way to Handle Property Taxes</p>
        </div>

        <div className={styles.cardsRow}>
          {cards.map((card) => (
            <div key={card.title} className={`${styles.cardWrap}`}>
              <span className={styles.iconOnly}>{card.icon}</span>

              <div className={styles.card}>
                <h3 className={styles.cardTitle}>{card.title}</h3>
                <p className={styles.cardDescription}>{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
